<div class="content">
    <div class="card">
      <div class="card-content">
        <div class="card-body">
  
          <button routerLink="/schools" title="{{ 'inputs.back' | translate }}" mat-icon-button *ngIf="type=='school' || type=='orders'">
            <mat-icon>keyboard_backspace</mat-icon>
            {{ 'inputs.back' | translate }}
          </button>

          <button routerLink="/reportages" title="{{ 'inputs.back' | translate }}" mat-icon-button *ngIf="type=='reportage'">
            <mat-icon>keyboard_backspace</mat-icon>
            {{ 'inputs.back' | translate }}
          </button>
  
          <h1 *ngIf="type=='school' || type=='reportage'">{{ 'titles.edit.send_notifications' | translate }}</h1>
          <h1 *ngIf="type=='orders'">{{ 'titles.edit.process_orders' | translate }}</h1>
  
          <div style="clear: left;"></div>
  
          <div class="media-body">
  
            <div class="contenedor" [formGroup]="studentForm">
              <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
  
              <mat-form-field appearance="legacy" *ngIf="type=='school' || type=='reportage'">
                <mat-label>{{ 'inputs.type' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'type'">
                  <mat-option *ngFor="let type of types" [value]="type.id">
                    {{type.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="legacy" *ngIf="type=='school' || type=='orders'">
                <mat-label>{{ 'inputs.stages' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'stages'" (selectionChange)="getGrades($event.value)">
                  <mat-option *ngFor="let stage of stages" [value]="stage.id">
                    {{stage.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <mat-form-field *ngIf="studentForm.value.stages != 'all' && studentForm.value.stages != null  && studentForm.value.stages != ''" appearance="legacy">
                <mat-label >{{ 'inputs.grades' | translate }}</mat-label>
                <mat-select matNativeControl [formControlName]="'grades'">
                  <mat-option *ngFor="let grade of grades" [value]="grade.id">
                    {{grade.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
  
              <div class="float-button-container">
                <button mat-fab color="primary" aria-label="save" (click)="checkNotifications()" *ngIf="type=='school'">
                  <mat-icon>send</mat-icon>
                </button>
                <button mat-fab color="primary" aria-label="save" (click)="checkReportageNotifications()" *ngIf="type=='reportage'">
                  <mat-icon>send</mat-icon>
                </button>
                <button mat-fab color="primary" aria-label="save" (click)="processOrders()" *ngIf="type=='orders'">
                  <mat-icon>send</mat-icon>
                </button>
              </div>
            </div>
            <div *ngIf="showPrimarySpinner" class="spinner-wrapper">
              <mat-spinner class="spinner-inner"></mat-spinner>
              {{ 'alerts.message_long_process' | translate }}
            </div>
  
          </div>
        </div>
      </div>
  
  
  
    </div>